export default "__VITE_ASSET__BC50RgHf__"